<template>
  <span>
    <div class="container" align="center">
      <div class="column" align="center">
        <div class="mt-2" id="chart">
          <AdminFinishedParticipants
            v-if="!this.insight_checkrows_participants.length"
            :listFiltered="listFiltered"
            :type="'noSelected'"
          />
          <pie-chart
            :style="window.width < 480 ? 'height:250px' : 'height:350px'"
            v-else
            class="pie-chart"
            :chart-data="datacollection"
            :options="chartOptions"
          ></pie-chart>
        </div>
      </div>
    </div>
  </span>
</template>
<script>
import PieChart from "@/components/Chart/chart";
import ChartJsPluginDataLabels from "chartjs-plugin-datalabels";
import AdminFinishedParticipants from "@/components/insight/Utils/AdminFinishedParticipants";
import { mapGetters } from "vuex";

export default {
  components: { PieChart, ChartJsPluginDataLabels, AdminFinishedParticipants },
  props: ["props", "listFiltered"],
  data() {
    return {
      parametre: "",
      window: {
        width: window.innerWidth,
      },
      datacollection: {},
      chartOptions: {
        animation: false,
        plugins: {
          datalabels: {
            color: "white",
            textAlign: "center",
            font: {
              weight: "bold",
              size: 23,
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: { enabled: false },
      },
    };
  },
  created() {
    //this.handleResize();
  },
  mounted() {
    this.fillData();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      window.width = newHeight;
    },
    insight_TotalParticipantPtsCheckboxs: [
      {
        handler: "fillData",
      },
    ],
    insight_TotalParticipantColorCheckboxs: [
      {
        handler: "fillData",
      },
    ],
  },
  computed: {
    ...mapGetters([
      "TotalParticipantPts",
      "TotalParticipantColor",
      "insight_backgroundColors",
      "array_participants_termine",
      "insight_checkrows_participants",
      "insight_TotalParticipantPtsCheckboxs",
      "insight_TotalParticipantColorCheckboxs",
    ]),
  },
  methods: {
    onResize() {
      this.window.width = window.innerWidth
    },
    fillData() {
      if (this.props === "energie") {
        // initialisation de mes parametre de chart en fonction de la props
        this.chartOptions = {
          animation: false,
          plugins: {
            datalabels: {
              formatter: function(value) {
                return value.replace(".", ",") + "%";
              },
              color: "white",
              textAlign: "center",
              font: {
                weight: "bold",
                size: 18,
              },
            },
          },
          responsive: true,
          maintainAspectRatio: false,
          tooltips: { enabled: false },
        };
        // calcul des energies en poucentage en fonction des checkboxs checkées
        this.parametre = this.insight_TotalParticipantPtsCheckboxs;
        const x = this.insight_checkrows_participants.length;
        this.parametre = [
          (this.parametre[0] / x).toFixed(1),
          (this.parametre[1] / x).toFixed(1),
          (this.parametre[2] / x).toFixed(1),
          (this.parametre[3] / x).toFixed(1),
        ];
        let pourcentageTotalSession =
          JSON.parse(this.parametre[0]) +
          JSON.parse(this.parametre[1]) +
          JSON.parse(this.parametre[2]) +
          JSON.parse(this.parametre[3]);
        // traitement des deux cas
        if (pourcentageTotalSession <= 100) {
          // si total en dessous de 100
          let calcDifference = 100 - pourcentageTotalSession;
          let totalParCouleur = calcDifference.toFixed(2);
          totalParCouleur = JSON.parse(totalParCouleur);
          this.parametre[0] = (
            JSON.parse(this.parametre[0]) + totalParCouleur
          ).toFixed(1);
        } else {
          // si total au dessus de 100
          let calcDifference = pourcentageTotalSession - 100;
          let totalParCouleur = calcDifference.toFixed(2);
          totalParCouleur = JSON.parse(totalParCouleur);
          this.parametre[0] = (
            JSON.parse(this.parametre[0]) - totalParCouleur
          ).toFixed(1);
        }
      } else if (this.props === "energie_dominante") {
        this.parametre = this.insight_TotalParticipantColorCheckboxs;
      } else {
        return false;
      }
      this.datacollection = {
        datasets: [
          {
            backgroundColor: [
              this.insight_backgroundColors[1],
              this.insight_backgroundColors[2],
              this.insight_backgroundColors[3],
              this.insight_backgroundColors[0],
            ],
            data: [
              this.parametre[1] === 0 ? "" : this.parametre[1],
              this.parametre[2] === 0 ? "" : this.parametre[2],
              this.parametre[3] === 0 ? "" : this.parametre[3],
              this.parametre[0] === 0 ? "" : this.parametre[0],
            ],
          },
        ],
      };
    },
  },
};
</script>
